import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="none"
      viewBox="0 0 25 25"
    >
      <path
        fill="#fff"
        d="M5.333 11.5h10l-3.29-3.29a1 1 0 111.41-1.42l4.29 4.3a2 2 0 01.59 1.41 2 2 0 01-.59 1.4l-4.29 4.3a1 1 0 01-1.41-1.42l3.29-3.28h-10a1 1 0 010-2z"
      ></path>
    </svg>
  );
}

export default Icon;
